module.exports = __webpack_public_path__ + "newlogo-324ee245.webp";